// tabs/CampaignTimelineTab.jsx
import React from "react";

export default function CampaignTimelineTab() {
  return (
    <section
      className="card lg section"
      aria-label="Unified SEA + India Timeline"
    >
      <div className="chips" style={{ marginBottom: 10 }}>
        <span className="pill">Timeline</span>
        <span className="pill">SEA + India</span>
        <span className="pill">Overview</span>
      </div>
      <h2 className="h2" style={{ marginBottom: 6 }}>
        Unified SEA + India Campaign Timeline
      </h2>
      <div className="xs muted" style={{ marginTop: 0, marginBottom: 12 }}>
        Coursera × Fairway Digital Media
      </div>
      <div className="chips" style={{ marginBottom: 12 }}>
        <span className="pill">
          SEA: Indonesia · Thailand · Philippines · Malaysia · Singapore
        </span>
        <span className="pill">India: FinServ + Tech/Software</span>
      </div>

      {/* Week 1 */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-head">
          <h3 className="h2">
            Week 1: <strong>Nov 24–28</strong> — Landing Pages + Infrastructure
            Setup
          </h3>
          <div className="chips">
            <span className="pill">On-track</span>
            <span className="pill" title="Holiday compression">
              Compressed (holiday week)
            </span>
          </div>
        </div>
        <div className="table-wrap">
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 140 }}>Date</th>
                <th>Milestone</th>
                <th style={{ width: 220 }}>Who</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sm">
                  Wed, <strong>Nov 26</strong>
                </td>
                <td className="sm">
                  Kickoff Sync: SEA + India scope alignment
                </td>
                <td className="sm">Coursera (APAC/India), Fairway, Dev</td>
                <td className="sm">
                  Confirm dual landing page setup: — <strong>India LP</strong>{" "}
                  (FinServ + Tech) — <strong>SEA LP</strong> (FinServ only)
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Nov 28</strong>
                </td>
                <td className="sm">Build LPs (x2)</td>
                <td className="sm">Dev + Marketing</td>
                <td className="sm">
                  Shared layout; add localized visuals/copy as needed for India
                  + SEA.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Nov 28</strong>
                </td>
                <td className="sm">Add Custom Form Questions</td>
                <td className="sm">Dev</td>
                <td className="sm">
                  Include disqualifying logic or “Accept All” option for both
                  LPs.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Nov 28</strong>
                </td>
                <td className="sm">Internal QA & Localization Review</td>
                <td className="sm">Regional Stakeholders (India + SEA)</td>
                <td className="sm">
                  Ensure country-specific nuance and compliance.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Nov 28</strong>
                </td>
                <td className="sm">Both Landing Pages Ready To Go Live</td>
                <td className="sm">Dev + Fairway</td>
                <td className="sm">
                  Ensure all tracking, form logic, and routing are working.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Week 2 */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-head">
          <h3 className="h2">
            Week 2: <strong>Dec 1–5</strong> — Campaign Launch Preparation
          </h3>
          <span className="pill">On-track</span>
        </div>
        <div className="table-wrap">
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 140 }}>Date</th>
                <th>Milestone</th>
                <th style={{ width: 200 }}>Who</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sm">
                  Mon, <strong>Dec 1</strong>
                </td>
                <td className="sm">Load Account + Title Lists</td>
                <td className="sm">Fairway Ops</td>
                <td className="sm">
                  Ensure proper segmentation: — <strong>India</strong>: FinServ
                  + Tech — <strong>SEA</strong>: FinServ only
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Tue, <strong>Dec 2</strong>
                </td>
                <td className="sm">Outbound Email Creative Finalized</td>
                <td className="sm">Fairway</td>
                <td className="sm">
                  Finalize email creative for India + SEA audiences.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Wed, <strong>Dec 3</strong>
                </td>
                <td className="sm">Convertr + LP Routing QA</td>
                <td className="sm">Fairway</td>
                <td className="sm">
                  Validate job title filters, geo filters, and form logic.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Thu, <strong>Dec 4</strong>
                </td>
                <td className="sm">Final Program Review</td>
                <td className="sm">Coursera + Fairway</td>
                <td className="sm">Confirm launch readiness.</td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Dec 5</strong>
                </td>
                <td className="sm">
                  {" "}
                  Program Launch (India only). SEA once TAL updated.)
                </td>
                <td className="sm">Fairway</td>
                <td className="sm">Campaigns begin live syndication.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Week 3 */}
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="section-head">
          <h3 className="h2">
            Week 3: <strong>Dec 8–12</strong> — Lead Delivery Begins
          </h3>
          <span className="pill">On-track</span>
        </div>
        <div className="table-wrap">
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 140 }}>Date</th>
                <th>Milestone</th>
                <th style={{ width: 200 }}>Who</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sm">
                  Mon, <strong>Dec 8</strong>
                </td>
                <td className="sm">Traffic Monitoring: India + SEA</td>
                <td className="sm">Fairway</td>
                <td className="sm">
                  Validate regional click traffic; filter issues.
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Tue–Thu, <strong>Dec 9–11</strong>
                </td>
                <td className="sm">First Batch QA: Leads by Market</td>
                <td className="sm">Fairway</td>
                <td className="sm">
                  Spot-check by Country / Function (L&D, HR, Tech) / Job Level
                  (Director+)
                </td>
              </tr>
              <tr>
                <td className="sm">
                  Fri, <strong>Dec 12</strong>
                </td>
                <td className="sm">First Leads Delivered (India)</td>
                <td className="sm">Fairway</td>
                <td className="sm">Coursera receives leads by region.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Bottom summaries */}
      <div className="grid g-2" style={{ marginTop: 12 }}>
        <div className="card">
          <div className="section-head">
            <h3 className="h2">Deliverables per Region</h3>
          </div>
          <div className="table-wrap">
            <table className="tbl">
              <thead>
                <tr>
                  <th style={{ width: 140 }}>Region</th>
                  <th style={{ width: 120 }}>Target Leads</th>
                  <th>Industry Focus</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="sm">India</td>
                  <td className="sm">220</td>
                  <td className="sm">FinServ (110) + Tech/Software (110)</td>
                </tr>
                <tr>
                  <td className="sm">SEA</td>
                  <td className="sm">220</td>
                  <td className="sm">FinServ only across 5 countries</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="card">
          <div className="section-head">
            <h3 className="h2">Optional Visual (for Dev)</h3>
          </div>
          <div className="sm">
            Build a tabbed/toggled map:
            <ul style={{ marginTop: 6, paddingLeft: 18 }}>
              <li>
                <strong>“SEA” tab</strong> — heatmap with tooltips (Leads, CPL,
                Top Titles).
              </li>
              <li>
                <strong>“India” tab</strong> — bubbles by industry (FinServ vs
                Tech) with same tooltips.
              </li>
            </ul>
            <div className="xs muted" style={{ marginTop: 8 }}>
              Placeholder: drop in <code>SEAHeatmapCard</code> and a new{" "}
              <code>IndiaIndustryBubbles</code> behind a two-tab switch.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
